import { render } from "./KnowledgeVersionHistory.vue?vue&type=template&id=b5617d9a&scoped=true"
import script from "./KnowledgeVersionHistory.vue?vue&type=script&lang=js"
export * from "./KnowledgeVersionHistory.vue?vue&type=script&lang=js"

import "./KnowledgeVersionHistory.vue?vue&type=style&index=0&id=b5617d9a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5617d9a"]])

export default __exports__